export default class InteractiveCatalog {

    constructor() {
        this.catalogId = '';
        this.title = '';
        this.navigationType = '';   // InteractiveCatalogNavigationType { MAGAZINE_2X1_ADAPTABLE, MAGAZINE_2X1_INDEPENDENT_ORIENTATIONS, INDEPENDENT_ORIENTATIONS, ONLY_HORIZONTAL, ONLY_VERTICAL }
        this.firstPageLeft = false; // 2x1
        this.horizontalSize = undefined;    // CanvasDimension
        this.verticalSize = undefined;      // CanvasDimension
        this.universalSize = undefined;     // CanvasDimension
        this.pages = [];        // List of InteractiveCatalogPage
        this.indexPages = [];   // List of InteractiveCatalogIndexPage
        this.numPages = 0;
        this.indexNumPage = 0;
        this.fullScreen = false;
        this.horizontalAlignmentType = ''; // AlignmentType { CENTERED, *BORDER_CENTERED_ALIGNED, BORDER_LEFT_ALIGNED, BORDER_RIGHT_ALIGNED }
        this.openActions = []; // List of ItemAction
        this.indexType = undefined; // IndexType
        this.backgroundColor = '';

        this._currentPageIndex = -1;
        this._currentPage = undefined;
        this._items = [];
    }

    goToPage(pageIndex) {
        if (pageIndex >= 0 && pageIndex < this.pages.length && pageIndex != this._currentPageIndex) {
            this._currentPageIndex = pageIndex;
            this._currentPage = this.pages[pageIndex];
            return true;
        }
        return false;
    }

    goToPrevPage() {
        return this.goToPage(this._currentPageIndex-1);
    }

    goToNextPage() {
        return this.goToPage(this._currentPageIndex+1);
    }

}
